import { VegaLoader } from "@heartlandone/vega";
import { _fetch } from 'Chore/Request';

let loaderId = null;
let pendingCount = 0;

export const fetchWithLoader = async ({
  api,
  method = "GET",
  data = null,
  containerSelector = "#loader-container"
}) => {
  const container = document.querySelector(containerSelector);
  if (pendingCount === 0) {
    if (container) {
      container.style.overflow = 'hidden';
    }
    loaderId = VegaLoader.load({ containerSelector });
  }
  pendingCount++;

  try {
    const response = await _fetch({ api, method, data });
    return response;
  } catch (err) {
    throw err;
  } finally {
    pendingCount--;
    if (pendingCount === 0 && loaderId !== null) {
      VegaLoader.close(loaderId);
        loaderId = null;
        if (container) container.style.overflow = 'auto';
    }
  }
};
